// extracted by mini-css-extract-plugin
module.exports = {"timePeriodSelector":"TimePeriodSelector_timePeriodSelector__FfJlR","title":"TimePeriodSelector_title__28eZm"};